import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { createGigApi } from "../../API/API";

function* createGigSaga(params) {
try {        
 const response = yield call(createGigApi, params);
  yield put({type: types.CREATE_GIG_SUCCESS, payload: response.data});
    } catch (error) {
        yield put({type: types.CREATE_GIG_FAILURE, error});
    }
}

export function* watchCreateGigSaga() {
    yield takeEvery(types.CREATE_GIG_REQUESTED, createGigSaga);
}


